var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":'editar-' + _vm.producto.id,"title":"Editar producto"},on:{"close":() => _vm.close(false)}},[_c('FormComponent',{attrs:{"producto":_vm.producto,"products":_vm.products,"desactivar":_vm.producto.productoSeleccionado ? true : false},on:{"terminado":_vm.editarProducto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }